// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__FF7Hf","input":"SearchBar_input__atL6R"};